import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Star } from "lucide-react";

export function VendorCard({ vendor }) {
  return (
    <div
      className="bg-card rounded-xl border border-border overflow-hidden card-hover"
      data-testid={`vendor-card-${vendor.slug}`}
    >
      <div className="h-24 bg-muted overflow-hidden">
        <img src={vendor.banner} alt="" loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="px-4 pb-4">
        <div className="-mt-8 mb-2 h-16 w-16 rounded-xl border-4 border-card overflow-hidden bg-muted">
          <img src={vendor.logo} alt={vendor.name} className="w-full h-full object-cover" />
        </div>
        <div className="flex items-center gap-1.5">
          <h3 className="font-semibold text-stone-900">{vendor.name}</h3>
          {vendor.verified && <BadgeCheck size={15} className="text-emerald-600" />}
        </div>
        <p className="text-xs text-stone-500">{vendor.category}</p>
        <div className="mt-2 flex items-center gap-3 text-xs text-stone-600">
          <span className="flex items-center gap-1">
            <Star size={13} className="fill-primary text-primary" strokeWidth={0} />
            {vendor.rating}
          </span>
          <span className="flex items-center gap-1">
            <MapPin size={13} /> {vendor.location}
          </span>
        </div>
        <div className="mt-2">
          {vendor.verified ? (
            <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-2 py-0.5">
              Verified Vendor
            </span>
          ) : (
            <span className="text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-100 rounded-full px-2 py-0.5">
              Verification Pending
            </span>
          )}
        </div>
        <Link
          to={`/vendor/${vendor.slug}`}
          data-testid={`view-store-${vendor.slug}`}
          className="mt-3 block text-center rounded-lg border border-border text-sm font-semibold py-2 text-stone-800 hover:border-secondary hover:text-secondary transition-colors"
        >
          View Store
        </Link>
      </div>
    </div>
  );
}
